// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","social-icon-text":"Footer_social-icon-text__3twMt","social-icon":"Footer_social-icon__1sujD","social-icon-link":"Footer_social-icon-link__6yldP"};